import { render, staticRenderFns } from "./WhatsappList.vue?vue&type=template&id=97ba50dc&scoped=true"
import script from "./WhatsappList.vue?vue&type=script&lang=js"
export * from "./WhatsappList.vue?vue&type=script&lang=js"
import style0 from "./WhatsappList.vue?vue&type=style&index=0&id=97ba50dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ba50dc",
  null
  
)

export default component.exports